<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
    animationData: {
        type: Function,
        required: true,
    },
    loop: {
        type: Boolean,
        default: false,
    },
    autoplay: {
        type: Boolean,
        default: true,
    },
    loopDelay: {
        type: Number,
        default: 0,
    }
});

const lottieContainer = ref(null);
let animation = null;
let observer = null;

const init = async () => {
    if (lottieContainer.value && !animation) {
        try {
            const lottie = (await import('lottie-web')).default;
            const animDataModule = await props.animationData();
            const animData = JSON.parse(JSON.stringify(animDataModule.default || animDataModule));

            animation = lottie.loadAnimation({
                container: lottieContainer.value,
                animationData: animData,
                renderer: 'svg',
                loop: props.loop,
                autoplay: props.autoplay,
            });

            if (props.loopDelay > 0 && !props.loop) {
                animation.addEventListener('complete', () => {
                    setTimeout(() => {
                        animation?.goToAndPlay(0, true);
                    }, props.loopDelay);
                });
            }
        } catch (e) {
            console.error('Error loading Lottie animation:', e);
        }
    }
};

onMounted(() => {
    if (lottieContainer.value) {
        observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                init();
                observer?.disconnect();
            }
        }, { rootMargin: '100px' });
        observer.observe(lottieContainer.value);
    }
});

onUnmounted(() => {
    animation?.destroy();
    observer?.disconnect();
});
</script>

<template>
    <div ref="lottieContainer"></div>
</template>
